var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-card',[_vm._v("\n  Link: Confirmed Showing Request\n  "),_c('message-card-item',{attrs:{"icon":"user","action-icon":"arrow-up-right"}},[_vm._v("\n    James Kent\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }